import * as React from "react";
import type { TemplateType } from "@/data/types";
import { SellerRelaunchTemplate } from "./SellerRelaunchTemplate";
import { SellerAnalysisTemplate } from "./SellerAnalysisTemplate";

type TemplateComponent = React.FC<{ data: any }>;

// Registry of presentation templates. New templates can be added here without
// touching routing or page components.
export const templateRegistry: Partial<Record<TemplateType, TemplateComponent>> = {
  seller_relaunch: SellerRelaunchTemplate,
  seller_analysis: SellerAnalysisTemplate,
};

export function getTemplate(type: TemplateType): TemplateComponent | undefined {
  return templateRegistry[type];
}
